// extracted by mini-css-extract-plugin
module.exports = {"container":"UnderConstruction_container__2xb2c","b":"UnderConstruction_b__17_mN"};